import { GET_LOT } from '../../constants';

const initialState = {
  data: null,
  loading: false,
  error: {}
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case GET_LOT.LOAD:
      return {
        ...state,
        loading: true
      };
    case GET_LOT.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false
      };
    case GET_LOT.FAIL:
      return {
        ...state,
        error: payload,
        loading: false
      };
    default:
      return state;
  }
}
